export default {
  api: {
    // url: 'http://223.248.182.223:8691'
    // url: 'http://192.168.5.159:8091'
    url: '/webapi'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js